import { fetchModel } from '@adobe/aem-react-editable-components'
import {
  DialogMaxWidthSizes,
  IconButtonStyles
} from '@dcxwam/dcx-wam-ui-foundations'

export const setDialogConfig = (
  isDialogOpen: boolean,
  setDialogIsOpen: (isOpen: boolean) => void,
  dialogTitle: string,
  closeAriaLabel: string,
  callback: () => void = () => {},
  dismissible: boolean = true
  // eslint-disable-next-line max-params
) => ({
  isOpen: isDialogOpen,
  onClose: () => {
    if (callback) {
      callback()
    }
    setDialogIsOpen(false)
  },
  zIndex: 1351,
  title: dialogTitle,
  maxWidth: DialogMaxWidthSizes.SM,
  fullWidth: true,
  dialogContentPadding: true,
  closeButtonStyle: IconButtonStyles.Default,
  dismissible,
  closeAriaLabel
})

export const fetchContainerContent = async (
  xfPath: string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  setContent: (content: any) => void
) => {
  const notifyMeModel = await fetchModel({
    cqPath: xfPath || ''
  })
  setContent({ ...notifyMeModel })
}
